module.exports = __webpack_public_path__ + "static/media/8@720w.0062b3f6.jpg";